import { createContext, type PropsWithChildren, useEffect, useState } from "react";
import {
  createPackageWithLeaguesStore,
  type PackageWithLeaguesStoreApi,
} from "../../store/packageWithLeaguesStore";

export const PackageWithLeaguesStoreContext = createContext<PackageWithLeaguesStoreApi | null>(
  null,
);

export const PackageWithLeaguesStoreProvider = ({ children }: PropsWithChildren) => {
  const [store] = useState(createPackageWithLeaguesStore);

  useEffect(() => () => store.getState().reset(), [store]);

  return (
    <PackageWithLeaguesStoreContext.Provider value={store}>
      {children}
    </PackageWithLeaguesStoreContext.Provider>
  );
};
